module.exports = __webpack_public_path__ + "img/fan01.df2d718c.png";